module.exports = __webpack_public_path__ + "media/images/sp/specials/common/store_sapporo-dbaed4ec92388b824e5ee4d3adaa474f.jpg";